import React from 'react'
import styled from 'styled-components'
import { Draggable } from 'react-beautiful-dnd'
import './DraggableCrossover.scss'

const Container = styled.div`
  border: 1px solid lightgrey;
  border-radius: 2px;
  padding: 8px;
  margin: 8px 0;
  display: flex;
  font-size: 12pt;
  transition: background-color 0.2s ease;
  color: ${props =>
    props.isDragging
      ? 'white'
      : 'black'};
  background-color: ${props =>
    props.isDragDisabled
      ? 'lightgrey'
      : props.isDragging
        ? '#A2998B'
        : '#E7DCDA'};
`

function Option(props) {
    return (
      <Draggable
        draggableId={props.option.id}
        index={props.index}
        isDragDisabled={props.isDisabled}
        className="draggable"
      >
        {(provided, snapshot) => (
          <Container
            {...provided.draggableProps}
            {...provided.dragHandleProps}
            ref={provided.innerRef}
            isDragging={snapshot.isDragging}
            isDragDisabled={props.isDisabled}
          >
            <div className='content'>
              {props.option.content}
            </div>
          </Container>
        )}
      </Draggable>
    )
}

export default Option